import styled,{ css } from 'styled-components'

export const MainContainer = styled.div`
  padding: 20px;
  width: 85vw;
`;

export const Header = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  border-radius: 7px;
  display:flex;
  justify-content : space-between;
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const Body = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  border-radius: 7px;
  display:flex;
  justify-content : space-between;
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ListTypeSelectorContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const ListTypeSelector = styled.div`
    color: ${props => props.active ? 'white': '#082243'};
    background-color: ${props => props.active ? '#253E5F':'white' };
    border-radius: 7px;
    padding: 5px 10px;
    font-size: smaller;
    font-weight: 600;

    &:hover {
        cursor: ${props => !props.active && 'pointer'};
        opacity: ${props => !props.active && '0.5'};
    }
`;

export const ModalContent = styled.div`
    padding: 20px;
`;

export const SmallHead = styled.div`
    text-align: center;
    background: #253E5F;
    border-radius: 10px;
    padding: 5px;
    color: white;
    font-weight: 600;
    margin: 5px;
`;

export const SmallContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-self: center;
    padding: 5px
    color: #253E5F;
`;

export const BuddyBlock = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    margin: 5px;
    padding: 5px;
`;

export const BuddyIcon = styled.div`
    width: 140px;
    height: 140px;
    border-radius: 7px;
    place-items: center;

    img {
        width: 125px;
        border-radius: 7px;
    }
`;
export const ArrowContainer = styled.div`
  text-align: end;
  position: absolute;
  right: 10px;
  bottom: 10px;
`;

export const ViewMoreButton = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  background: #fff;
  color: #02475c;
  border: 1px solid #02475c;
  border-radius: 5px;
  transition: all 0.2s;
  padding: 6px 12px;

  &:hover { 
    background: #02475c;
    color: #fff;
  }
`

let styles = {
  container: {
    padding: '1%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection:'column',
  },

  table: {
    boxShadow: '1px 5px 25px -5px rgba(74,74,74,1)',
    padding: '1%',
    borderRadius:'10px'
  },

  header: {
    backgroundColor: '#253E5F',
    color: 'white',
    padding: '5px',
    textAlign: 'center',
    fontWeight: '600',
    borderRadius: '5px',
    fontSize: 'large',
    boxShadow: '1px 5px 25px -5px rgba(74,74,74,1)',
  },

  main_header: {
    backgroundColor: '#253E5F',
    color: 'white',
    padding: '5px',
    textAlign: 'center',
    fontWeight: '600',
    borderRadius: '5px',
    fontSize: 'large'
  },

  sub_header: {
    padding: '1%',
    marginBottom: '1%',        
    backgroundColor: '#253E5F',
    color: 'white',
    borderRadius: '5px'
  },

  dropdown: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor:'white',
  },

  dropdownMenu: {
    width: '100%',
    maxHeight: '100vh',
    overflow: 'scroll'
  },

  loading:{
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100%',
    height: '100%'
  },

  nodata:{
    position: 'absolute',
    top: '25%',
    left: '50%',
    width: '50%',
    height: '50%'
  },

  statsContainer:{
    backgroundColor:'white',
    boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.10)',
    borderRadius:'12px',
    marginTop:'15px'
  },

  stats:{
    display:'flex',
    justifyContent:'center',
    cursor:'pointer',
    borderRadius:'12px'
  },
  statsBlock: {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '10px',
  minWidth: '100px',
  },

  statCircle: {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
  },

  statLabel: {
    fontWeight: '600',
    marginTop: '8px',
    fontSize: '14px',
    textAlign: 'center',
  },


}
export default styles
